export default {
  methods: {
    mapLayerSnowmakingPipelinesAdd() {
      this.initPollSnowmakingPipelines();
      this.map.addSource("snowmaking-pipelines-source", {
        type: "geojson",
        data: this.computedSnowmakingPipelinesGeoJson
      });

      this.map.addLayer({
        id: "snowmaking-pipelines-fatfinger",
        type: "line",
        source: "snowmaking-pipelines-source",
        paint: {
          "line-color": "Brown",
          "line-width": 30,
          "line-opacity": 0
        }
      });

      this.map.addLayer({
        id: "snowmaking-pipelines",
        type: "line",
        source: "snowmaking-pipelines-source",
        paint: {
          "line-color": "#013bff ",
          "line-width": 2
        },
        layout: {
          "line-join": "round",
          "line-cap": "round"
        }
      });

      this.map.addLayer({
        filter: ["all", ["==", "pipeline_name", "abc123"]],
        id: "snowmaking-pipelines-hover",
        type: "line",
        source: "snowmaking-pipelines-source",
        paint: {
          "line-color": "Purple",
          "line-width": 10,
          "line-blur": 2
        }
      });

      this.map.moveLayer("snowmaking-pipelines-hover", "marker-layer-lines");
      this.map.moveLayer("snowmaking-pipelines", "marker-layer-lines");
      this.map.moveLayer(
        "snowmaking-pipelines-fatfinger",
        "marker-layer-lines"
      );
    },
    mapLayerSnowmakingPipelinesRemove() {
      this.cancelPollSnowmakingPipelines();
      this.map.removeLayer("snowmaking-pipelines-hover");
      this.map.removeLayer("snowmaking-pipelines");
      this.map.removeLayer("snowmaking-pipelines-fatfinger");
      this.map.removeSource("snowmaking-pipelines-source");
    },
    initPollSnowmakingPipelines() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipelines",
        dept: "snowmaking",
        layer: "pipelines",
        token: this.computedAuthToken
      });
      this.pollSnowmakingPipelinesInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipelines",
          dept: "snowmaking",
          layer: "pipelines",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollSnowmakingPipelines() {
      this.pollSnowmakingPipelinesInterval = clearInterval(
        this.pollSnowmakingPipelinesInterval
      );
    }
  },
  computed: {
    computedSnowmakingPipelinesGeoJson() {
      return this.$store.state.mapLayers.snowmaking.layers.pipelines.geojson;
    },
    computedSnowmakingPipelinesMapVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.pipelines.visibility
        .mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.snowmaking.layers.pipelines.geojson": {
      handler() {
        if (this.computedSnowmakingPipelinesGeoJson) {
          this.mapLayerSnowmakingPipelinesRemove();
          this.mapLayerSnowmakingPipelinesAdd();
        }
      }
    },
    "$store.state.mapLayers.snowmaking.layers.pipelines.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerSnowmakingPipelinesAdd();
      } else {
        this.mapLayerSnowmakingPipelinesRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollSnowmakingPipelines();
  }
};
